module.exports = __webpack_public_path__ + "img/47f7d8a065c348dff77b997bbdc1e4c5.png";